var map = {
	"./Vidhvastha Publicity Still 13.jpg": 7280,
	"./Vidhvastha Publicity Still 14.jpg": 6083,
	"./Vidhvastha Publicity Still 17.jpg": 6372,
	"./Vidhvastha Publicity Still 4.jpg": 6326,
	"./Vidhvastha Publicity Still 6.jpg": 8628,
	"./Vidhvastha Publicity Still 7.jpg": 6673
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2555;